import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
export default function TextTransition(param) {
    var children = param.children;
    return /*#__PURE__*/ _jsx(AnimatePresence, {
        mode: "popLayout",
        children: /*#__PURE__*/ _jsx(motion.div, {
            layout: true,
            initial: {
                opacity: 0,
                y: '50%'
            },
            whileInView: {
                opacity: 1,
                y: 0
            },
            exit: {
                opacity: 0,
                y: '-50%'
            },
            transition: {
                duration: 0.25,
                type: 'spring',
                stiffness: 200,
                damping: 15
            },
            children: children
        })
    });
}
